import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZorroModule } from '../../../../../modules/zorro.module';
import { RubricLevelBadgeComponent } from '../../../rubric-level-badge/rubric-level-badge.component';
import { StrideLogStudentSummary } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-stride-log-summary',
	standalone: true,
	imports: [CommonModule, ZorroModule, RubricLevelBadgeComponent],
	templateUrl: './stride-log-summary.component.html',
	styleUrl: './stride-log-summary.component.scss',
})
export class StrideLogSummaryComponent {
	public summary = input<StrideLogStudentSummary | undefined>(undefined);
}
